<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Created At"
    >
      <b-input-group>
        <flat-pickr
          v-model="createdAtFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group
      label="Created By"
      @click.native.stop
    >
      <v-select
        v-model="createdByFilterValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        placeholder="Select from list"
        multiple
        :options="userOptions"
        :reduce="user => user._id"
      />
    </b-form-group>
    <b-form-group label="Status">
      <b-form-checkbox
        v-for="option in statusOptions"
        :key="option.value"
        v-model="statusFilterValue"
        :value="option.value"
        name="flavour-3a"
      >
        {{ option.text }}
      </b-form-checkbox>
    </b-form-group>
    <b-button
      variant="outline-primary"
      size="sm"
      class="mr-1"
      @click="clearFilter"
    >
      Clear All
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      @click="applyFilter"
    >
      Apply Filter
    </b-button>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BFormCheckbox, BRow, BCol, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BFormCheckbox,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    flatPickr,
  },
  props: {
    createdAtFilter: {
      type: [String, null],
      default: null,
    },
    statusFilter: {
      type: [Array, null],
      default: null,
    },
    createdByFilter: {
      type: [Array, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    userOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      createdAtFilterValue: this.createdAtFilter,
      statusFilterValue: JSON.parse(JSON.stringify(this.statusFilter)) || [],
      createdByFilterValue: JSON.parse(JSON.stringify(this.createdByFilter)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    createdAtFilter: {
      immediate: true,
      handler(val) {
        this.createdAtFilterValue = val
      },
    },
    createdByFilter: {
      immediate: true,
      handler(val) {
        this.createdByFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    statusFilter: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:createdAtFilter', this.createdAtFilterValue)
      this.$emit('update:createdByFilter', this.createdByFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.createdAtFilterValue = ''
      this.createdByFilterValue = []
      this.statusFilterValue = []
      this.$emit('update:createdAtFilter', this.createdAtFilterValue)
      this.$emit('update:createdByFilter', this.createdByFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
